<template>
	<div class="container_head ">
		<van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="list">
			<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
				<div v-if="columnId=='xqgs'" class="xqgs">
					<div class="card" v-for="item in list" @click="changeview('/common/detail/xqgs',item.id)">
						<div class="left">
							<img :src="item.img||defaultimg" alt="">
						</div>
						<div class="right">
							<div class="title">{{item.title}}</div>
							<div class="desc">{{item.publishDate}}</div>
						</div>
					</div>
				</div>

				<div v-if="columnId=='sqkb'" class="sqkb">
<van-search
  v-model="value"
  show-action
  label="标题查询"
  placeholder="请输入标题进行查询"
  @search="onSearch"
>
  <template #action>
    <div @click="onSearch">查询</div>
  </template>
</van-search>



					<div class="card sqkbcard" v-for="item in list" @click="changeview('/common/detail/sqkb',item.id)">
						<!-- <div class="left">
							<img :src="item.img||defaultimg" alt="">
						</div> -->
						<div class="kbright right">
							<div v-show="!item.isRead" class="new">新</div>
							<div class="title">{{item.title}}</div>
							<div class="desc mt5">{{item.publishDate.slice(0,10)}}</div>
						</div>
					</div>
				</div>
				<div v-if="columnId=='xxgg'" class="sqkb">
<!-- <van-search
  v-model="value"
  show-action
  label="标题"
  placeholder="请输入标题进行查询"
  @search="xxggSearch"
>

</van-search> -->


            <div class="search datesearch" style="margin-top:10px" v-if="showXxggFilters">
                <span>标题：</span>
                <input type="text" v-model="value">
            </div>
            <div class="search datesearch" style="margin-top:10px" v-if="showXxggFilters">
                <span>开始时间：</span>
                <input type="date" v-model="starttime">
            </div>
            <div class="search datesearch" style="margin-top:10px" v-if="showXxggFilters">
                <span>截止时间：</span>
                <input type="date" v-model="endtime">
            </div>

			            <div class="btns" v-if="showXxggFilters">
                <button class="searchbt" @click="czxxgg">重置</button>
                <button class="searchbt" style="margin-left:20px" @click="xxggSearch">搜索</button>
            </div>


					<div class="card sqkbcard" v-for="item in list" @click="changeview('/common/detail/xxgg',item.id)">
						<!-- <div class="left">
							<img :src="item.img||defaultimg" alt="">
						</div> -->
						<div class="kbright right">	
							<div class="title">{{item.title}}</div>
							<div class="desc mt5">{{item.publishDate.slice(0,10)}}</div>
						</div>
					</div>
				</div>


				<div v-if="columnId=='bdyw'" class="sqkb">

            <div class="search datesearch" style="margin-top:10px">
                <span>标题：</span>
                <input type="text" v-model="value">
            </div>
            <div class="search datesearch" style="margin-top:10px">
                <span>开始时间：</span>
                <input type="date" v-model="starttime">
            </div>
            <div class="search datesearch" style="margin-top:10px">
                <span>截止时间：</span>
                <input type="date" v-model="endtime">
            </div>

			            <div class="btns">
                <button class="searchbt" @click="czbdyw">重置</button>
                <button class="searchbt" style="margin-left:20px" @click="bdywSearch">搜索</button>
            </div>


					<div class="card sqkbcard" v-for="item in list" @click="changeview('/common/detail/bdyw',item.id)">
						<!-- <div class="left">
							<img :src="item.img||defaultimg" alt="">
						</div> -->
						<div class="kbright right">	
							<div class="title">{{item.title}}</div>
							<div class="desc mt5">{{item.publishDate.slice(0,10)}}</div>
						</div>
					</div>
				</div>
				<div v-if="columnId=='zbsh'" class="zbsh">
					<div class="card" v-for="item in list" @click="changeview('/common/detail/zbsh',item.lifeId)">
						<div class="title">{{item.partyLiftTitle}}</div>
						<div class="desc">{{item.liftTime}}</div>
					</div>
				</div>
				<div v-if="columnId=='qdzb'" class="qdzb">
					<div class="card" v-for="item in list" @click="changeview('/hsyw/zbdy',item.id)">
						<div class="title">{{item.partyBranchName}}</div>
						<div class="desc">地址：{{item.address}}</div>
					</div>
				</div>
				<div v-if="columnId=='wdxx'" class="wdxx">
					<div class="carditem" v-for="item in list" >
						<div class="time">{{item.messageTime}}</div>
						<div class="card" @click="changeview('/common/detail/wdxx',item.wechatTemplatemessageId,item.title)">
							<div class="title">{{item.title}}</div>
							<div class="desc">{{item.message}}</div>
							<van-divider :style="{  margin: '10px 0' }" />
							<div class="ckxq">查看详情>></div>
						</div>
					</div>
				</div>
				<div v-if="columnId=='fags'" class="fags">
					<div class="card" v-for="item in list" >
						<div class="title" style="color: #01b4ff;">{{item.title}}</div>
						<div class="desc">{{item.content}}</div>
						<div style="font-size: 14px;">同意：{{item.agreeNum}} 反对：{{item.againstNum}} 弃权：{{item.waiverNum}}</div>
					</div>
				</div>
				<div v-if="columnId=='symx'" class="fags">
					<div class="card" v-for="item in list" >
						<div class="title"> <span class="blue">[{{item.type}}]</span>{{item.reason}}</div>
						<div class="desc">{{item.otherAccount}}</div>
						<div class="money">{{item.paymentMethod != '0' ? item.paymentMethod : '现金'}} ¥{{item.paymentAmount}}</div>
					</div>
				</div>
				<div class="item" v-for="(item,index) in list" :key="index" @click="changeview('/wyfw/wyjj/ldz',item.id)" v-if="columnId=='ldz'">
					<div class="title">
						<div class="bline"></div>
						<span>{{item.no}}</span>
					</div>
					<div class="xxj" >楼栋长：<span>{{item.manageName}}</span></div>
				</div>
			</van-list>
		</van-pull-refresh>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		List,Divider 
	} from 'vant';
	Vue.use(List).use(Divider);
	import { mapState, mapMutations } from "vuex";
	export default {
		data() {
			return {
				list: [],
				value:'',
				loading: false,
				finished: false,
				refreshing: false,
				columnId: '',
				pageNum:0,
				            starttime:'',
            endtime:'',
				defaultimg:require('../../assets/grzx/test.png'),
				showXxggFilters: false,
				
			};
		},
		computed: {
			...mapState(['userInfo','identity','houseId']),
		},
		mounted() {
			
		},
		updated() {
			this.columnId = this.$route.params.columnId;
			if (this.columnId == "zbsh") {
				 this.$emit('fatherMethod',{
					 title:'支部生活'
				 })
			} else if (this.columnId == "xqgs") {
				this.$emit('fatherMethod',{
					title:'小区公告'
				})
			} else if (this.columnId == "qdzb") {
				this.$emit('fatherMethod',{
					title:'小区党支部'
				})
			}else if (this.columnId == "wdxx") {
				this.$emit('fatherMethod',{
					title:'我的消息'
				})
			}else if (this.columnId == "fags") {
				this.$emit('fatherMethod',{
					title:'结果公示'
				})
			}else if (this.columnId == "symx") {
				this.$emit('fatherMethod',{
					title:'使用明细'
				})
			}else if (this.columnId == "sqkb") {
				this.$emit('fatherMethod',{
					title:'社区快报'
				})
			}else if (this.columnId == "ldz") {
				this.$emit('fatherMethod',{
					title:'楼栋长'
				})
			}else if (this.columnId == "xxgg") {
				this.$emit('fatherMethod',{
					title:'政策法规'
				})
			}else if (this.columnId == "bdyw") {
				this.$emit('fatherMethod',{
					title:'本地要闻'
				})
			}
		},
		methods: {
			        czxxgg(){
            this.starttime = ''
            this.endtime = ''
            this.value = ''
            this.list = []
			this.pageNum=0
			this.requestdata3('')
        },
			        czbdyw(){
            this.starttime = ''
            this.endtime = ''
            this.value = ''
            this.list = []
			this.pageNum=0
			this.requestdata2('/view/xxfb/viewLocalNews/list',"")
        },
			onSearch(){
				console.log(this.value)
				this.requestdata1('/api/v1/wygl/notice/list',this.value)
			},
			xxggSearch(){
				this.list=[]
				this.pageNum=0
				console.log(this.value)
				this.requestdata3(this.value)
			},
			bdywSearch(){
				this.list=[]
				this.pageNum=0
				console.log(this.value)
				this.requestdata2('/view/xxfb/viewLocalNews/list',this.value)
			},
			onRefresh() {
				this.finished = false;
				// 重新加载数据
				// 将 loading 设置为 true，表示处于加载状态
				this.loading = true;
				this.onLoad();
			},
			onLoad() {
				setTimeout(() => {
					if (this.refreshing) {
						// 清空列表数据
						this.pageNum = 0;
						this.list = [];
						this.refreshing = false;
					}
					 if (this.columnId == "xqgs") {
						this.requestdata('/api/v1/wygl/publicity/list')
						return
					}else if(this.columnId == "qdzb"){
						this.requestdata('/api/v1/wygl/partybranch/view')
						return
					}else if (this.columnId == "sqkb") {
						if(this.value==''){
							this.requestdata('/api/v1/wygl/notice/list')
						}else{
							this.requestdata1('/api/v1/wygl/notice/list',this.value)
						}
						return
					}else if (this.columnId == "symx") {
						this.requestdata('/api/v1/maintenance/payments')
						return
					}else if (this.columnId == "zbsh") {
						this.requestdata('/api/v1/wygl/partybranchlife/viewlist')
						return
					}else if (this.columnId == "fags") {
						this.requestdata('/api/v1/maintenance/results')
						return	
					}else if (this.columnId == "wdxx") {
						this.requestdata('/api/v1/wygl/mynews/list')
						return	
					}else if (this.columnId == "ldz") {
						this.requestdata('/api/v1/wygl/buildingmanager/viewlist')
						return	
					}else if (this.columnId == "xxgg") {
						this.requestdata3("")
						return
					}else if (this.columnId == "bdyw") {
						this.requestdata2('/view/xxfb/viewLocalNews/list',"")
						return	
					}
					for (let i = 0; i < 4; i++) {
						 if (this.columnId == "fags") {
							this.list.push({
								title:'小区路灯维修'+(this.list.length + 1),
								desc:'方案：检查电线杆线路问题，如是灯泡坏了，则更换灯泡。',
								money:"271.00",
								img:require('../../assets/grzx/test.png')
							});
						}
					}
				}, 500);
			},
			requestdata(url){
				this.$axios.get(url, {
					params: {
						pageNum:this.pageNum,
						pageSize:15,
						houseId:sessionStorage.getItem('houseId'),
					}
				}).then(res => {
					this.list.push(...res.data);
					console.log("🚀 ~ file: list.vue:228 ~ requestdata ~ res.data:", res.data)
						console.log("🚀 ~ file: list.vue:233 ~ requestdata ~ res.total:", res.total)

					this.pageNum++;
					this.loading = false;
					if (this.list.length >= res.total) {
						this.finished = true;
					}
				});
			},
			requestdata1(url,val){//新增关键字查询
					this.list=[]
				this.$axios.get(url, {
					params: {
						pageNum:0,
						pageSize:15,
						houseId:sessionStorage.getItem('houseId'),
						title:val
					}
				}).then(res => {
					this.list.push(...res.data);
					this.pageNum++;
					this.loading = false;
					if (this.list.length >= res.total) {
						this.finished = true;
					}
				});
			},
			requestdata2(postUrl,val){//新增信息公告 和 本地要闻的

      let data = new FormData();
      var jsonData = {};
		  (jsonData = {
			pageSize:15,
			pageNum:this.pageNum,
			orderByColumn: 'publishDate,createdDate',
			isAsc:'DESC',
			regionId:"",
			title:val,
			publishStatus:1,
			beginTime: this.starttime,
			endTime:this.endtime
		  });
      for (let key in jsonData) {
        data.append(key, jsonData[key]);
      }
      this.$axios.post(postUrl, data).then((res) => {
		  console.log("🚀 ~ file: list.vue:277 ~ this.$axios.post ~ res.content:", res.content)
			console.log("🚀 ~ file: list.vue:283 ~ this.$axios.post ~ res.totalElements:", res.totalElements)
					this.list.push(...res.content);
					this.pageNum++;
					this.loading = false;

					if (this.list.length >= res.totalElements) {
						this.finished = true;
					}
      });

			},
			requestdata3(val){//政策法规新接口GET请求
				this.$axios.get('/screen/v1/home/regulationsList', {
					params: {
						pageSize: 15,
						pageNum: this.pageNum,
						title: val || '',
						startTime: this.starttime,
						endTime: this.endtime
					}
				}).then((res) => {
					// axios拦截器已处理，res就是data部分：{total, pageNum, pageSize, data: [...]}
					if(res && res.data && Array.isArray(res.data)) {
						this.list.push(...res.data);
						this.pageNum++;
						this.loading = false;
						if (this.list.length >= res.total) {
							this.finished = true;
						}
					} else {
						this.loading = false;
						this.finished = true;
					}
				}).catch(() => {
					this.loading = false;
					this.finished = true;
				});
			},
			changeview(path,id,type) {
				console.log(path,id,type)
				this.$router.push({
					path,
					query:{
						type,
						id,
						columnId:this.columnId,
					}
				});
			}
		}
	};
</script>

<style lang="less" scoped>
.fags{
	.card{
		border-radius: 10px;
		overflow: hidden;
		box-shadow: 2px 2px 3px #ccc;
		padding: 10px;
		margin: 15px;
		background-color: #fff;
		.left{
			width: 100px;
			float: left;
			img{
				width: 100px;
				height: 85px;
				object-fit: cover;
			}
		}
		.right{
			margin-left: 110px;
			
		}




		.title{
			font-size: 16px;
			margin-bottom: 5px;
		}
		.desc{
			color: #b5b5b5;
			font-size: 14px;
			margin-bottom: 5px;
		}
		.money{
			color:#ff5816;
			font-size: 16px;
		}
	}
}

		        .search{
					width: 100%;
            display: flex;
			justify-content: space-around;
            align-items: center;
            font-size: 13px;
            text-align: center;
            span{
                width: 25%;
            }
        }
        .datesearch{
            input{
                width: 65%;
            }
        }

		 .btns{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 10px;
        }
        .searchbt{
            height: 30px;
            width: 100px;
            background: #00b5ff;
            border-radius: 10px;
            border: none;
            outline: none;
            color: #fff;
        }
.item{
	width: 92%;
	margin-left: 4%;
	display: flex;
	flex-direction: column;
	line-height: 30px;
	border-bottom: 1px solid #ebedf0;
	.title{
		color: #333333;
		font-size: 18px;
		display: flex;
		align-items: center;
		margin-top: 10px;
		.bline{
			width: 4px;
			height: 20px;
			background-color: #28aff6;
		}
		span{
			margin-left: 10px;
		}
	}
	.xxj{
		margin-left: 20px;
		span{
			color: #999999;
		}
	}
}
.xqgs,.sqkb {
	.sqkbcard{
		padding: 10px 20px !important;
	}
	.card {
		padding: 10px;
		background-color: #fff;
		border-bottom: 1px solid #eee;
		overflow: hidden;

		.left {
			width: 100px;
			float: left;

			img {
				width: 100px;
				height: 65px;
				object-fit: cover;
			}
		}
		.kbright{
			margin: 0 !important;
			position: relative;
		}
		.new{
			height: 15px;
			width: 15px;
			background-color: #FF455B;
			display: inline-block;
			padding: 0 2px;
			text-align: center;
			vertical-align: middle;
			font-style: normal;
			color: #fff;
			overflow: hidden;
			line-height: 15px;
			font-size: 11px;
			border-radius: 4px;
			font-weight: 200;
			position: absolute;
			left: -17px;
			top: 3px;
		}
		.right {
			margin-left: 110px;

			.title {
				font-size: 16px;
				margin-bottom: 5px;
			}
			.mt5{
				margin-top: 5px !important;
			}
			.desc {
				color: #aaa;
				font-size: 14px;
				margin-top: 20px;
			}
		}
	}
}
.qdzb,.zbsh{
	.card{
		padding: 10px 15px;
		background-color: #fff;
		border-bottom: 1px solid #eee;
		overflow: hidden;
		.title{
			font-size: 16px;
			margin-bottom: 5px;
		}
		.desc{
			color: #aaa;
			font-size: 14px;
		}
	}
}
.wdxx{
	.carditem{
		margin: 15px;
		.time{
			color: #b9b9b9;
			font-size: 13px;
			text-align: center;
		}
	}
	
	.card{
		border-radius: 10px;
		overflow: hidden;
		box-shadow: 2px 2px 3px #ccc;
		padding: 10px;
		margin: 15px 0;
		background-color: #fff;
		.title{
			font-size: 16px;
		}
		.desc{
			font-size: 13px;
			color: #aaaaaa;
		}
		.ckxq{
			text-align: right;
			font-size: 13px;
			color: #aaaaaa;
		}
	}
}
.blue{
	color: #00b5ff;
}
</style>
